<template>
	<div class="g-page">
		<div class="g-head flex-between-center">
			<img class="logo" :src="systemConfig.scs_login_logo">
			<div class="flex">
				<a v-if="this.systemConfig.pc_enabled == 'ON' && this.systemConfig.pc_mall_url" class="item" :href="systemConfig.pc_mall_url" target="_blank">前往商城</a>
				<p v-if="systemConfig.scs_investment_hotline" class="item">招商服务热线：{{systemConfig.scs_investment_hotline}}</p>
			</div>
		</div>
		<div class="g-body">
			<div class="g-main">
				<div class="login">
					<h1 class="title">欢迎登录</h1>
					<c-tab-list ref="tabList" class="tabs" :tabs="typeList" @change="tabHandle"></c-tab-list>

					<c-form v-show="type == 1" ref="phoneLogin" class="form">
						<c-input v-model="phone" class="item" type="text" name="phone" placeholder="请输入手机号" :clear="false" @enter="login">
							<template #prependIcon>
								<i class="item-icon tf tf-phone tf-fw"></i>
							</template>
						</c-input>
						<c-input class="item" type="text" name="verify_code" placeholder="短信验证码" :clear="false" @enter="login">
							<template #prependIcon>
								<i class="item-icon tf tf-smscode tf-fw"></i>
							</template>
							<template #append>
								<a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
							</template>
						</c-input>
					</c-form>

					<c-form v-show="type == 2" ref="userLogin" class="form">
						<c-input class="item" type="text" name="company_name" placeholder="请输入商家名称" :clear="false">
							<template #prependIcon>
								<i class="item-icon tf tf-company tf-fw"></i>
							</template>
						</c-input>
						<c-input class="item" type="text" name="user_name" placeholder="请输入用户名" :clear="false">
							<template #prependIcon>
								<i class="item-icon tf tf-username tf-fw"></i>
							</template>
						</c-input>
						<c-input class="item" type="password" name="user_pwd" placeholder="请输入密码" :clear="false">
							<template #prependIcon>
								<i class="item-icon tf tf-password tf-fw"></i>
							</template>
						</c-input>
					</c-form>
					<c-button class="button" color="main" @click="login">登录</c-button>
					<div class="handle flex-between-center" v-show="type == 2">
						<a></a>
						<a v-if="systemConfig.scs_customer_service_telephone" @click="forgetPassword()">忘记密码?</a>
					</div>
				</div>
			</div>
		</div>
		<div class="g-foot">{{systemConfig.scs_copyright}}</div>
		<p style="display: none;">©2023 杭州云创数智科技有限公司 提供技术支持</p>

		<c-dialog ref="stationedList" width="600" :title="false" :close-button="false" :button="false">
			<dl class="factory-list">
				<dt>请选商家</dt>
				<dd>
					<ul>
						<li v-for="(item, i) in stationedList" :key="i" class="flex-center" @click="factoryHandle(item)">
							<i class="icon tf-company"></i>
							<p class="flex-grow ellipsis">{{item.company_name}}</p>
						</li>
					</ul>
				</dd>
			</dl>
		</c-dialog>
	</div>
</template>

<script>
	import {cryptoJs} from '@deanwu/vue-component-library'
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				typeList: [{
					name: '账号登录',
					value: 2
				}, {
					name: '手机号登录',
					value: 1
				}],
				type: 2,
				phone: '',
				countdown: false,
				stationedList: [],
                getSmscodeCount:0   //获取验证码次数
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			
			countdownText() {
				return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
			}
		},
		
		methods: {
			tabHandle(item, index) {
				this.type = item.value;
			},

			getSmscode() {
				if (this.countdown) return;
				if (!this.phone) {
					this.$message({
						message: '请输入手机号'
					});
					return;
				}
				const phoneRegex = /^1\d{10}$/;
				// 使用test方法检查手机号是否符合格式
				if (!phoneRegex.test(this.phone)) {
					this.$message({
						message: '请输入正确的手机号'
					});
					return;
				}

				this.request({
					url: '/stationed/user/login/verify/code',
					data: {
						client: 0,
						phone: this.phone
					},
					loading: true,
					success: () => {
                        this.getSmscodeCount = this.getSmscodeCount+1;
						this.$message({
							message: '验证码已发送'
						});
						!function loop(s) {
							this.countdown = s;
							if (s == 0) return;
							setTimeout(() => {
								loop.call(this, --s);
							}, 1000);
						}.call(this, 60);
					}
				});
			},

			login() {
				if (this.type == 1) {
					this.$refs.phoneLogin.submit({
						url: '/stationed/user/login/verify/code/check',
						breakWhenFail: true,
						rule: {
							phone: '请输入手机号',
                            verify_code: [{
                                type: 'empty',
                                message: '请输入短信验证码'
                            }, {
                                type: 'function',
                                fun: (value, data) => {
                                    if (this.getSmscodeCount == 0){
                                        return false;
                                    }
                                    return true;
                                },
                                message: '请先获取短信验证码'
                            }]
						},
						dataFormatter: data => {
							return data;
						},
						success: (data, res) => {
							this.getFactory(res);
						}
					});
				} else {
					this.$refs.userLogin.submit({
						url: '/stationed/user/login',
						breakWhenFail: true,
						rule: {
							company_name: '请输入商家名称或ID',
							user_name: '请输入用户名',
							user_pwd: '请输入密码'
						},
						dataFormatter: data => {
							data.stationed_type = 1;
							data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
							return data;
						},
						success: (data, res) => {
							this.loginRedirect(res);
						}
					});
				}
			},

			getFactory(phone) {
				this.request({
					url: '/stationed/list/by/user',
					data: {
						phone: phone
					},
					loading: true,
					success: data => {
						if (!data.length) {
							this.$confirm({
								type: 'message',
								message: `该手机号尚未注册或相关账号已被禁用，请联系管理员，或拨打客服热线：${this.systemConfig.scs_customer_service_telephone}`,
								buttonName: '我知道了',
								cancelButton: false
							})
						} else if (data.length == 1) {
							this.factoryHandle(data[0]);
						} else {
							this.stationedList = data;
							this.$refs.stationedList.open();
						}
					}
				});
			},

			factoryHandle(data) {
				this.request({
					url: '/stationed/user/login/byid',
					data:{
						user_id: data.user_id
					},
					success: data => {
						this.loginRedirect(data);
					}
				});
			},

			forgetPassword() {
				this.$confirm({
					type: 'message',
					message: `如果忘记密码可与相关负责人索要账号密码，或拨打客服热线：${this.systemConfig.scs_customer_service_telephone}`,
					buttonName: '我知道了',
					cancelButton: false
				})
			},

			loginRedirect(data) {
				this.$store.commit('setSession', data.user_info.session);
				this.$store.commit('setUserInfo', data.user_info);
				this.$store.commit('setNav', data.user_menu_list || []);
				this.$store.commit('setAuth', Array.from(data.user_menu_key_list, item => item.menu_unique_key));
				this.navigateTo('/');
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-head {
			box-sizing: border-box;
			max-width: 1440px;
			height: 100px;
			padding: 0 30px;
			margin: 0 auto;
			
			.logo {
				height: 70px;
			}
			
			.item {
				font-size: 14px;
				
				&:nth-child(n+2) {
					&:before {
						content: '|';
						margin: 0 10px;
					}
				}
			}
		}
		
		.g-body {
			height: 600px;
			background-image: url('~@/assets/image/login_bg.jpg');
			background-size: cover;
			
			.g-main {
				max-width: 1400px;
				padding: 0 20px;
				margin: 0 auto;
				
				.login {
					float: right;
					box-sizing: border-box;
					width: 400px;
					height: 455px;
					border-radius: 50px 0 50px 0;
					padding: 0 40px;
					margin-top: 70px;
					overflow: hidden;
					background: #fff;
					
					.title {
						margin-top: 20px;
						line-height: 60px;
						font-size: 22px;
						font-weight: normal;
						text-align: center;
					}
					
					.form {
						row-gap: 0;
						padding: 0;
						
						.item {
							height: 40px;
							margin-bottom: 17px;
							
							&-icon {
								margin: 0 10px 0 12px;
								font-size: 14px;
								color: #333;
							}
						}
					}
					
					.button {
						width: 100%;
						height: 46px !important;
						margin-bottom: 26px;
						font-size: 18px !important;
					}
					
					.handle {
						a {
							font-size: 13px;
							color: #0060EF;
						}
					}
				}
			}
		}
		
		.g-foot {
			line-height: 56px;
			font-size: 12px;
			text-align: center;
			color: #999;
		}

		.tabs {
			margin-bottom: 30px;

			>>> ul {
				border-bottom-color: #E5E5E5;

				li.z-crt {
					font-size: 18px;
				}
			}
		}

		.smscode {
			display: block;
			margin-top: 9px;
			margin-right: 8px;
			line-height: 20px;
			font-size: 12px;
			color: var(--color-main);
			
			&.z-dis {
				color: #999;
			}
		}
	}

	.factory-list {
		border-radius: 10px;
		padding: 0 30px 40px;
		background: #FFFFFF;

		dt {
			line-height: 100px;
			font-size: 24px;
			font-weight: bold;
			text-align: center;
		}

		dd {
			li {
				height: 60px;
				border-radius: 4px;
				padding: 0 22px;
				margin-bottom: 13px;
				color: #fff;
				background: var(--color-main);
				cursor: pointer;

				&:hover {
					background:#32373E;
				}

				.icon {
					margin-right: 16px;
					font-size: 20px;
				}
			}
		}
	}
</style>
